export default function NexGenLogo({ dark = false, compact = false }) {
  return (
    <div
      className={`nexgen-logo ${dark ? "is-dark" : ""} ${compact ? "is-compact" : ""}`}
      aria-label="NexGen Technology Solutions"
    >
      <svg viewBox="0 0 96 96" aria-hidden="true">
        <rect x="10" y="14" width="52" height="12" rx="6" />
        <rect x="24" y="42" width="52" height="12" rx="6" opacity=".72" />
        <rect className="accent" x="38" y="70" width="48" height="12" rx="6" />
      </svg>
      {!compact && (
        <span className="nexgen-wordmark">
          <span>
            <strong>Nex</strong>Gen
          </span>
          <small>Technology Solutions</small>
        </span>
      )}
    </div>
  );
}
